import React, { createContext, useContext, useState } from "react";

// 創建 Context
const PageContext = createContext();

// 提供 Provider
export const PageProvider = ({ children }) => {
  const [pageData, setPageData] = useState({
    browsePermissions: [],
    otherPermissions: [],
    pageName: "",
    breadcrumbs: [],
  });
  const [nowMenu, setNowMenu] = useState(localStorage.getItem("nowMenu") || "");
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  return (
    <PageContext.Provider
      value={{
        pageData,
        setPageData,
        nowMenu,
        setNowMenu,
        sidebarCollapsed,
        setSidebarCollapsed,
      }}
    >
      {children}
    </PageContext.Provider>
  );
};

// 自定義鉤子供子組件使用
export const usePageContext = () => {
  const context = useContext(PageContext);
  if (!context) {
    throw new Error("usePageContext 必須在 PageProvider 中使用");
  }
  return context;
};
